export default __webpack_public_path__ + "357407e795e9cfe7e95497a2eda41bb2.svg";